import VanillaTilt from 'vanilla-tilt'
import CONFIG from '@js/config'
import utils from '@js/utils'
import { trackSection } from '@/scripts/ga'
import '@js/app'
import scrollbar from '@js/scrollbar'

import '@comp/animate_title/animate_title'
import '@comp/animate_title/animate_title.scss'

import BannerSwiper from '@comp/banner_swiper/banner_swiper'

import compBlockCard from '@comp/block_card/block_card.ejs'
import '@comp/block_card/block_card.scss'

// import WorkSelector from './selector/selector.ejs'
import './selector/selector.scss'
import './selector/selector'

import './style.scss'

function fetchList (pageCurrent, filter, cb) {
    $.ajax({
        type: 'GET',
        url: `${CONFIG.API_BASE}work`,
        data: {
            page: pageCurrent,
            limit: 9,
            filter: filter ? decodeURIComponent(filter) : ''
        },
        dataType: 'json',
        success: function (msg) {
            if (msg.message) {
                return cb(new Error(msg.message))
            }
            let result = []
            msg.rows.forEach(row => {
                result.push({
                    id: row.id,
                    title: row.work_company,
                    desc: row.title,
                    bgUrl: row.cover,
                    link: `work_detail.html?id=${row.id}`,
                    track: `Work #${row.title}`
                })
            })

            return cb(null, {
                count: msg.count,
                rows: result
            })
        },
        error: function (err) {
            console.log('err', err)
            location.href = '404.html'
        }
    })
}

function fetchBanner (cb) {
    $.ajax({
        type: 'GET',
        url: `${CONFIG.API_BASE}feature_work`,
        dataType: 'json',
        success: function (msg) {
            if (msg.message) {
                return cb(new Error(msg.message))
            }

            return cb(null, msg)
        },
        error: function (err) {
            console.log('err', err)
            location.href = '404.html'
        }
    })
}

$(() => {
    trackSection('Work')
    let pageCurrent = utils.getURLParam('page') || 1
    let filter = utils.getURLParam('filter')

    if (filter) {
        $('.full-banner.work-banner').addClass('filter')
    } else {
        fetchBanner(function (err, result) {
            if (err) {
                location.href = '404.html'
                return
            }
            let swiperData = []

            result.forEach(item => {
                swiperData.push({
                    title: item.work_company,
                    desc: item.title,
                    bgUrl: item.slide_banner,
                    link: `work_detail.html?id=${item.id}`,
                    bgColor: item.bg_color,
                    track: `Work #${item.title}`
                })
            })
            let options = {}
            if (swiperData.length === 1) {
                options = {
                    autoplay: false
                }
            }

            const swiper = new BannerSwiper(swiperData, 'work-banner-swiper', options, false)
            swiper.init()
        })
    }

    fetchList(pageCurrent, filter, function (err, result) {
        if (err) {
            location.href = '404.html'
            return
        }
        let workBlockHtml = ''
        result.rows.forEach((item, index) => {
            let html = compBlockCard(item)
            workBlockHtml += `
                <div class="${index % 9 === 0 ? 'col-sm-8 col-md-6' : 'col-sm-6 col-md-3'} col-xs-12 slideup block-wrap" ${index % 9 === 5 ? 'style="margin-left: 0"' : ''} >
                    ${html}
                </div>
                `
        })
        $('#work-block-wrap').html(workBlockHtml)

        VanillaTilt.init(document.querySelectorAll('.tilt-link'), {
            max: 2,
            speed: 600
        })
    })

    // const industriesOptions = [
    //     {
    //         title: 'Aerospace', desc: []
    //     },
    //     {
    //         title: 'Architecture', desc: []
    //     },
    //     {
    //         title: 'Financial Service', desc: []
    //     },
    //     {
    //         title: 'Consumer Products', desc: []
    //     },
    //     {
    //         title: 'Film & TV', desc: []
    //     },
    //     {
    //         title: 'Food & Baverages', desc: []
    //     },
    //     {
    //         title: 'Fasion', desc: []
    //     },
    //     {
    //         title: 'Entertainment', desc: []
    //     },
    //     {
    //         title: 'Travel', desc: []
    //     },
    //     {
    //         title: 'Transportation', desc: []
    //     },
    //     {
    //         title: 'Retail Store', desc: []
    //     },
    //     {
    //         title: 'Gaming & E-sports', desc: []
    //     }
    // ]
    //
    // const businessOptions = [
    //     {
    //         title: 'Innovate', desc: ['Brand innovation strategy', 'Consumer research and insights', 'Product / Service concept ideation']
    //     },
    //     {
    //         title: 'Create', desc: ['Brand design and application', 'Retail space & digital interaction design', 'Product & packaging design']
    //     },
    //     {
    //         title: 'Communicate', desc: ['Integrated marketing communications', 'Influencer marketing', 'Social CRM solution', 'Multi-channel E-commerce operation']
    //     },
    //     {
    //         title: 'Digitalize', desc: ['Digital strategy and infrastructure design', 'Operations digitalization', 'Interactive system design', 'Data science']
    //     }
    // ]
    //
    // const workSelectorHtml = WorkSelector({
    //     selectorData: [
    //         {
    //             label: 'INDUSTRIES',
    //             options: industriesOptions
    //         },
    //         {
    //             label: 'BUSINESS',
    //             options: businessOptions
    //         }
    //     ]
    // })
    // $('#work_selector-wrap').html(workSelectorHtml)

    $('.load-more a').click(function () {
        const $parent = $(this).parent()
        if ($parent.hasClass('loading')) {
            return
        }
        $parent.addClass('loading')
        pageCurrent += 1
        fetchList(pageCurrent, filter, (err, result) => {
            if (err) {
                location.href = '404.html'
                return
            }

            $parent.removeClass('loading')
            if (!result.rows.length) {
                pageCurrent -= 1
                return
            }

            let workBlockHtml = ''
            result.rows.forEach((item, index) => {
                let html = compBlockCard({
                    ...item
                })
                workBlockHtml += `
                <div class="${index % 9 === 0 ? 'col-sm-8 col-md-6' : 'col-sm-6 col-md-3'} col-xs-12 slideup block-wrap" ${index % 9 === 5 ? 'style="margin-left: 0"' : ''} >
                    ${html}
                </div>
                `
            })
            $('#work-block-wrap').append(workBlockHtml)

            VanillaTilt.init(document.querySelectorAll('.tilt-link'), {
                max: 2,
                speed: 600
            })
        })
    })

    scrollbar.init()
})
